import React from 'react';
import {utils} from '../../utils/utils'
import {itemActions} from '../../utils/itemActions'

class FullscreenSocialDownload extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    const arrowImageClass = "progallery-svg-font-icons-download" + (utils.isStoreGallery() ? '-store' : '');
    const {layout, device} = this.props
    var curItem = this.props.current.item;
    var downloadClassNames = [`fullscreen-social-download ${arrowImageClass}`, itemActions.viewClassName(layout, device)].join(' ') + (utils.isMobile ? ' mobile-social-icon' : '');
    return (this.props.styleParams.allowDownload && !curItem.isDemo) ? (curItem.isText ? (
      <a className={downloadClassNames}
         style={this.props.style}
         tabIndex={utils.getTabIndex('fullscreenDownload')}
         aria-label={`Download ${curItem.type} to your device`}
         role="button"
         onClick={evt => {
           evt.stopPropagation()
           itemActions.downloadTextItem(allProps, 'fullscreen')
         }}
      >
      </a>
    ) : (
      <a className={downloadClassNames}
         style={this.props.style}
         tabIndex={utils.getTabIndex('fullscreenDownload')}
         aria-label={`Download ${curItem.type} to your device`}
         role="button"
         href={curItem.download_url['mp4'] || curItem.download_url['webm'] || curItem.download_url['img']}
         download="download" target="_blank"
         onClick={ () => logger.track('download', {origin: 'fullscreen'}) }>
      </a>
    )) : <i/>;

  }
}

export default FullscreenSocialDownload;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenSocialDownload.js